import controller from './brands.controller';
import template from './brands.view.html';

let BrandsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default BrandsComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/home/brands/brands.component.js
 **/